export const ORDER_STATUS_LABELS = {
  CREATED: "Creada",
  PENDING_APPROVAL: "Pendiente por aprobar",
  PAID: "Pagada",
  PROCESSING: "En Proceso",
  SHIPPED: "Enviada",
  DELIVERED: "Entregada",
  CANCELLED: "Cancelada",
  PENDING_PROOF: "Pendiente de comprobante",
};

export const PAYMENT_METHOD_LABELS = {
  CASH: "Efectivo",
  TRANSFER: "Transferencia",
  PROVIDER: "Pasarela",
  LINK: "Link de pago",
};

export const PAYMENT_PROVIDER_LABELS = {
  WOMPI: "Wompi",
  STRIPE: "Stripe",
  COIN: "Coin Payment",
  MONNET: "Monnet",
};

export const DELIVERY_TYPE_LABELS = {
  PHYSICAL: "Físico",
  DELIVERY: "Domicilio",
  STORE_PICKUP: "Recoger en tienda",
};


export const getStatusColor = (status) => {
  switch (status) {
    case "CREATED":
      return "secondary";
    case "PENDING_APPROVAL":
      return "info";
    case "PAID":
      return "primary";
    case "PROCESSING":
      return "warning";
    case "SHIPPED":
      return "info";
    case "DELIVERED":
      return "success";
    case "CANCELLED":
      return "danger";
    case "PENDING_PROOF":
      return "info";
    default:
      return "light";
  }
};
